import { render, staticRenderFns } from "./RadioWrapper.vue?vue&type=template&id=5aa17619&scoped=true&"
import script from "./RadioWrapper.vue?vue&type=script&lang=js&"
export * from "./RadioWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RadioWrapper.vue?vue&type=style&index=0&id=5aa17619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa17619",
  null
  
)

export default component.exports